import React from "react";
import "./LeaderBuildWithUs.css";
import bgGradient from "../../Assets/rock-bg.png";
import handsImage from "../../Assets/leadership/white-rock-with-hands.png";
import { useNavigate } from "react-router-dom";

const BuildWithUs = () => {
  const navigate=useNavigate();
  return (
    <section className="build-with-us">
      {/* <img src={bgGradient} alt="Background" className="build-bg" /> */}

      <div className="build-content-wrapper">
        <h2 className="build-heading">Build With Us</h2>

        <div className="build-box">
          <div className="text-content">
            <h3>Let’s Build Together</h3>
            <p>
              Whether you’re an experienced professional, an upcoming innovator, or a 
              changemaker at heart, VCNR is a place where leaders don’t just grow, they transform.
            </p>
            <a href="/Career"><button className="build-partner-btn">Partner With Our Group</button></a>
          </div>

          <div className="image-content">
            <img src={handsImage} alt="Hands Raised" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default BuildWithUs;
